import { render, staticRenderFns } from "./GlobalNotifyMessage.vue?vue&type=template&id=0a2d2e56&scoped=true&"
import script from "./GlobalNotifyMessage.vue?vue&type=script&lang=js&"
export * from "./GlobalNotifyMessage.vue?vue&type=script&lang=js&"
import style0 from "./GlobalNotifyMessage.vue?vue&type=style&index=0&id=0a2d2e56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2d2e56",
  null
  
)

export default component.exports